import { ServerUrls } from '../../app/ServerUrls';
import { Messages } from '../../codegen/Localize';
import { Location } from '../../common/react/Location';
import { Module } from '../Module';
import { BrowserTitleService } from '../../commonInfra/services/BrowserTitleService';
import { CreateSiteAction } from '../services/CreateSiteAction';

export interface IAddSiteScope extends ng.IScope {
  createSite: () => void;
}

export class AddSiteCtrl {

  public static $inject = [
    '$scope',
    'CreateSiteAction'
  ];

  constructor(
    scope: IAddSiteScope,
    createSiteAction: CreateSiteAction
  ) {
    BrowserTitleService.setTitleWithTranslatedSpace({translatedSpaceName: Messages.serverSettings_addSite()});
    scope.createSite = () => createSiteAction.execute(scope)
      .then(() => {
        Location.instance.setUrl(ServerUrls.getInstance().sitesUrl());
      });
  }
}

Module.instance().controller('AddSiteCtrl', AddSiteCtrl);
